import React, {PureComponent} from 'react';
import {
  Card, CardBody, Col, Progress,
} from 'reactstrap';
import TrendingUpIcon from 'mdi-react/TrendingUpIcon';
import axios from "axios";
import Util from "../../../Common/util";
import API from "../../../Common/api";

/*<div className="progress-wrap progress-wrap--small progress-wrap--blue-gradient progress-wrap--rounded">
          <p className="dashboard__booking-card-progress-label progress__label">79%</p>
          <Progress value={79} />
        </div>*/

var url = window.location.hostname; 

class TotalCustomers extends PureComponent{
  state = {
    count : 0
  }
  
DashboardCount = () => {
  const payload = {
    "location":"vapi",//this.getCookie('selectedLocation'),
    "report_type": "ValueInventory",
    "report_detailed" : ""
  };
  
  API.post('/reports/dashboardStaticCount/v1/', { param: payload })
    // axios('http://'+url+'/reports/dashboardStaticCount/v1/',
    // {
    //   method: 'POST',
    //   headers: {
    //     Accept: 'application/json',
    //     'Content-Type': 'application/json',
    //   },
    //   data:{
    //     "location":"vapi",//this.getCookie('selectedLocation'),
    //     "report_type": "ValueInventory",
    //     "report_detailed" : ""
    //   }
    // })
    .then((response) => {
	  //console.log(response);
	  if(response.data.data[0].sum == undefined){
		 this.setState({
			count : 0
		})
	  }else{
		  this.setState({
			count : response.data.data[0].sum
		})
	    
	  }
      
   })
  }
  
  
   getCookie(cname) {
          var name = cname + "=";
          var decodedCookie = decodeURIComponent(document.cookie);
          var ca = decodedCookie.split(';');
          for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return "";
        }
  
  
  
  componentDidMount(){
	 if (url === "localhost") {
        url= "15.206.34.41"+":8088";

      }else{
        url= window.location.hostname+":8088";
      }
	  
    this.DashboardCount();
  }
  
render(){
    return (
  <Col md={12} xl={3} lg={6} xs={12}>
    <Card>
      <CardBody className="dashboard__booking-card">
        <div className="dashboard__booking-total-container">
          <h5 className="dashboard__booking-total-title dashboard__booking-total-title--blue">
            {this.state.count}
          </h5>
        </div>
        <h5 className="dashboard__booking-total-description">Stock Value by MRP</h5>
        
      </CardBody>
    </Card>
  </Col>
);
  }
}

export default TotalCustomers;
